/**
 * todo: destroy the datepicker on unload
 */
define('controllers/roomselection',['require','layout','utils','services/bookingService','rv!templates/booking/roomselection','rv!templates/partials/messenger','rv!templates/partials/nightlyRates'],function (require) {
    'use strict';
    var layout = require('layout');
    var utils = require('utils');
    var bookingService = require('services/bookingService');
    return {
        /**
         * Note we store one hotel in state at a time, so they can quickly switch back from booking when looking at different rooms.
         */
        load: function (hotelId, data, state) {
            if (hotelId != null) {
                hotelId = hotelId.replace('?hid=', ''); //so old links work that get redirected here from old aspx page...
            }
            if (!utils.isInt(hotelId)) {
                window.location.hash = '/destinations';
            }
            hotelId = parseInt(hotelId);
            this.state = state;
            layout.authorize('Member,CallCenter,Admin', function () {
                var cachedHotelId = utils.tryGetValue(this.state, 'data.hotel.HotelID');
                if (cachedHotelId === hotelId) {
                    this.init(this.state.data);
                } else {
                    this.state.availability = this.getDefaultAvailability();
                    this.loading = $.get('/api/hotels/getroomselectiondata/?hotelId={0}'.format(hotelId));
                    this.loading.then(this.init.bind(this));
                }
            }.bind(this));
        },
        
        /**
         * Note if the user had session planning data and we don't have any availability in state, 
         *      we automatically check availability (means they checked at one hotel and are probably 
         *      going to check at a different hotel)--unless they're dba--might be doing manual book
         */
        init: function (rawData) {
            this.state.data = rawData;
            var data = this.buildData(this.state.data);
            var h = data.hotel;
            this.initRactive(data);
            this.setBreadCrumbs(h.HotelID);
            this.setupDateRangePicker(data);
            layout.initGlobalHandlers();
            document.title = h.PublicName;
            //NO AUTO CHECKING UNTIL date picker issue is understood and resolved (see below in onCheckAvailability)
            //if (!window.ServerData.user.isDba && data.hadSession && !this.haveRooms()) {
            //    this.onCheckAvailability(); 
            //}
        },

        /**
         * Note that anytime availability changes, we store it in state for quick access
         */
        initRactive: function (data) {
            this.ractive = layout.initRactive({
                data: data,
                messenger: this.getDefaultMessenger(),
                availability: this.state.availability,
                ServerData: window.ServerData,
                contentUrl: window.ServerData.StaticContentUrl,
                childOptions: this.getChildOptions(data.hotel.IsAdultAge),
                isDba: window.ServerData.user.isDba,
                isMAW: (window.ServerData.user.id.toString().toLowerCase() === '6D3FC413-D74E-494D-8CCE-D5E534ABEC36'.toLowerCase() || window.ServerData.user.id.toString().toLowerCase() === 'B5634949-0BB7-4719-BCE8-7559D4EC9724'.toLowerCase()) ? true : false,
                Id: window.ServerData.user.id.toString(),
                showGdsData: false,
                dateSeparator: ' - ',
                getPerfectSaverImage: this.getPerfectSaverImage.bind(this),
                getPerfectSaverMessage: this.getPerfectSaverMessage.bind(this)
            },
                require('rv!templates/booking/roomselection'),
                {
                    partials: {
                        messenger: require('rv!templates/partials/messenger'),
                        nightlyRates: require('rv!templates/partials/nightlyRates')
                    }
                }
            );
            this.ractive.on({
                onChildrenChange: this.onChildrenChange.bind(this),
                onDateBoxChange: this.onDateBoxChange.bind(this),
                clearRooms: this.clearRooms.bind(this),
                onCheckAvailability: this.onCheckAvailability.bind(this),
                onGetRateDetails: this.onGetRateDetails.bind(this),
                onPhoneChange: this.onPhoneChange.bind(this),
                onManualBook: this.onManualBook.bind(this)
            });
            this.ractive.observe('availability', function(availability) {
                this.state.availability = availability;
            }.bind(this), { init: false });
        },

        /**
         * Set up raw data to be more friendly for ractive view and validation
         */
        buildData: function (data) {
            var today = new Date();
            var tomorrow = new Date().addDays(1);
            data.planningData.Timeline.FromDate = Date.parse(utils.formatDate(data.planningData.Timeline.FromDate || today));
            data.planningData.Timeline.ToDate = Date.parse(utils.formatDate(data.planningData.Timeline.ToDate || tomorrow));
            data.planningData.TravelerInfo.CoMemberBook = data.planningData.TravelerInfo.CoMemberBook.toString();
            data.planningData.TravelerInfo.CoMemberAltName = data.planningData.TravelerInfo.CoMemberAltName == null ? '' : data.planningData.TravelerInfo.CoMemberAltName.toString();
            return data;
        },

        /**
         * Build child age options based on the hotel's isAdultAge
         */
        getChildOptions: function (isAdultAge) {
            var childOptions = [];
            for (var i = 0; i < isAdultAge; i++) {
                childOptions.push(i);
            }
            return childOptions;
        },

        /**
         * set up the date range picker control
         */
        setupDateRangePicker: function (data) {
            var sep = this.ractive.get('dateSeparator');
            var format = 'M/d/yyyy';
            var from = utils.formatDate(data.planningData.Timeline.FromDate);
            var to = utils.formatDate(data.planningData.Timeline.ToDate);
            $('#dateRange').daterangepicker({
                opens: 'left',
                format: format,
                separator: sep,
                minDate: window.ServerData.user.isDba ? null : Date.today(),
                startDate: from,
                endDate: to
            }, this.onDatePickerChange.bind(this))
            .val('{0}{1}{2}'.format(from.toString(format), sep, to.toString(format)));
        },

        /**
         * Handles when selecting with picker
         * Note when dates are picked from the date range picker that aren't the same as the currently selected dates, we automatically check availability.
         * @param {Date} from 
         * @param {Date} to 
         */
        onDatePickerChange: function (from, to) {
            var oldFrom = this.ractive.get('data.planningData.Timeline.FromDate');
            var oldTo = this.ractive.get('data.planningData.Timeline.ToDate');
            var f = 'M/dd/yyyy';
            if (oldFrom == null ||
                oldTo == null ||
                oldFrom.toString(f) !== from.toString(f) ||
                oldTo.toString(f) !== to.toString(f)
            ) {
                this.clearRooms();
                this.ractive.set('data.planningData.Timeline.FromDate', from);
                this.ractive.set('data.planningData.Timeline.ToDate', to);
                //this.onCheckAvailability(); this just fucks shit up--make them press the goddamn button
            }
        },

        /**
         * Handles when date range box is manually typed into (parse out the dates and set them if they're valid)
         * Note we try to split the dates by '-' or 'to' or 'through'. Then we check that there are 2 and that they are both valid dates.
         * @param {RactiveEvent} e 
         */
        onDateBoxChange: function (e) {
            this.clearRooms();
            var $this = $(e.node);
            var value = $this.val();
            var dates = value.split(/-|to|through/g);
            var from = Date.parse(dates[0]);
            var to = Date.parse(dates[1]);
            if (!utils.isDate(from) || !utils.isDate(to)) {
                from = null;
                to = null;
                this.ractive.set('messenger.Errors', ['Invalid date range entered']);
            }
            this.ractive.set('data.planningData.Timeline.FromDate', from);
            this.ractive.set('data.planningData.Timeline.ToDate', to);
        },

        clearRooms: function () {
            this.ractive.set('availability', this.getDefaultAvailability());
            this.ractive.set('messenger', this.getDefaultMessenger());
        },

        getDefaultMessenger: function() {
            return {
                InfoMessages: this.haveRooms() ? [] : ['Press "Check Availability" to check room availability for your new criteria.'],
                Errors: [],
                Warnings: []
            };
        },

        /**
         * if we have rooms in state
         * @returns {bool} 
         */
        haveRooms: function() {
            var roomCount = utils.tryGetValue(this.state, 'availability.Rooms.length');
            return roomCount != null && roomCount > 0;
        },

        getDefaultAvailability: function () {
            return {
                rooms: [],
                AchCount: 0
            };
        },

        setBreadCrumbs: function (hotelId) {
            layout.setBreadCrumbs([
                {
                    name: 'Destinations',
                    url: '/#/destinations'
                },
                {
                    name: 'Hotel Details',
                    url: '/#/hotel-adestinn-details/{0}'.format(hotelId)
                },
                {
                    name: 'Room Selection'
                }
            ]);
        },

        /**
         * When children number changes, build age boxes (unless the hotel doesn't care how old the children are)
         */
        onChildrenChange: function (e) {
            this.clearRooms();
            var childCount = parseInt($(':selected', e.node).val());
            var children = [];
            for (var i = childCount - 1; i >= 0; i--) {
                children.push(0);
            }
            this.ractive.set('data.planningData.TravelerInfo.ChildAges', children);
        },

        /**
         * Validate and disable button while getting rooms
         * Note we need to layout.initGlobalHandlers, so tracking attributes work--might want to define a ractive directive for this though...
         * Note we clear manual booking for availability request, so server doesn't think this is a manual booking--but we keep it when doing a manual booking, of course.
         * Note everytime we check availability, store resulting availability for quick load of this page for checking out different rooms.
         * Note we pass in a copy of the validated planningData in case it gets changed prior to this finishing loading (e.g. clear dates while checking results in invalid dates for choose button if we don't use the validated planningData)
         */
        onCheckAvailability: function (e) {
            if (e != null) {
                e.original.preventDefault();
            }
            var planningData = this.ractive.get('data.planningData');
            var copyPlanning = utils.copy(planningData);
            copyPlanning.ManualBooking = null;
            if (this.validateCheckAvailability(copyPlanning)) {
                //todo: somehow rooms come back, but have invalid/missing to/from dates built into their BookingUrl (rooms use the validated deep copy planning data to build the url). This results in an error like "No tax data for [hotelid] for 1/1/0001" upon clicking "Choose"--really annoying and difficult to reproduce...
                //so somehow, copyPlanning has its to/from modified between initiating the ajax request and success??
                //consider returning the planning data with the rooms response and using that. But shouldn't have to do that!!
                console.log('{0} - {1}'.format(utils.formatDate(copyPlanning.Timeline.FromDate), utils.formatDate(copyPlanning.Timeline.ToDate)));
                this.ractive.set('checking', true);
                this.cancelCheckRequest();
                this.checkRequest = $.postJSON('/api/hotels/checkavailability', {
                    planningData: copyPlanning,
                    showGdsData: this.ractive.get('showGdsData')
                });
                this.checkRequest.then(
                    function (availability) {
                        availability.Rooms.forEach(function (r) {
                            var roomData = this.getRoomPlanningData(utils.copy(copyPlanning), r); //need a separate planning data obj for each room too. Probably more efficient way to do this, but fixing a prod bug...instead probably just build this when getting rate details...
                            r.planningData = roomData;
                            r.BookingUrl = this.getBookUrl(roomData); 
                        }.bind(this));
                        this.ractive.set('messenger', {});
                        this.ractive.set('availability', availability).then(layout.initGlobalHandlers);
                    }.bind(this),
                    function(err) {
                        this.ractive.set('messenger.Errors', window.Utilities.getFriendlyErrors(err));
                        this.ractive.set('availability', this.getDefaultAvailability());
                    }.bind(this)
                )
                .always(function() {
                    if (this.checkRequest.statusText !== 'abort') { //keep the loading gif up if we're just cancelling a previous request
                        this.ractive.set('checking', false);
                    }
                }.bind(this));
            }
        },

        validateCheckAvailability: function (planningData) {
            var errors = [];
            var from = planningData.Timeline.FromDate;
            var to = planningData.Timeline.ToDate;
            var today = Date.parse(new Date().toString('M/d/yyyy'));
            if (!utils.isDate(from) || !utils.isDate(to)) {
                errors.push('Please select a valid date range.');
            } else if (from > to) {
                errors.push('Checkin date must be after checkout date');
            } else if (from < today || to < today) {
                errors.push('Checkin and Checkout dates must be in the future.');
            }
            this.ractive.set('messenger.Errors', errors);
            return errors.length === 0;
        },

        /**
         * build a url to the booking page with the given planning data.
         * @param {PlanningData} planningData 
         * @returns {string} 
         */
        getBookUrl: function(planningData) {
            var qs = bookingService.serializePlanning(planningData);
            return '/#/book/{0}'.format(qs);
        },

        /**
         * set room-specific props on planning data, so we can check rate details or choose it.
         */
        getRoomPlanningData: function (planningData, room) {
            planningData.DestinationInfo.RoomTypeCode = room.RoomType;
            planningData.DestinationInfo.RoomCorporateDisc = room.CorporateDiscountCode;
            planningData.DestinationInfo.Rate.RatePlanCode = room.RateCode;
            planningData.DestinationInfo.RoomName = room.Name;
            return planningData;
        },

        /**
         * build up a hash to the booking page, with the info in the manual book form
         */
        onManualBook: function (e) {
            e.original.preventDefault();
            var planningData = this.ractive.get('data.planningData');
            planningData.ManualBooking.RoomDescription = '{0}<br/>{1}'.format(planningData.DestinationInfo.RoomName, planningData.ManualBooking.RoomDescription);
            if (this.validateManualBook(planningData)) {
                window.location.hash = this.getBookUrl(planningData)
                                  .replace(/^\/#/, '');
            }
        },

        validateManualBook: function(planningData) {
            var errors = [];
            //todo: mimic planningdata.ValidateChooseRoom()
            this.ractive.set('messenger.Errors', errors);
            return errors.length === 0;
        },

        getPerfectSaverMessage: function (psPreviewAmount, achCount, linked) {
            var monthlyAmount = achCount > 0 ? psPreviewAmount / achCount : 0;
            if (linked) {
                if (psPreviewAmount <= 0) {
                    return 'You\'re saving enough to book this room.';
                }
                return achCount > 0 ?
                    '{0} added to your next {1}contribution{2} pays for this booking.'.format(utils.formatMoney(monthlyAmount), achCount > 1 ? achCount + ' ' : '', achCount > 1 ? 's' : '') :
                    'Need to add {0} to pay for this booking.'.format(utils.formatMoney(psPreviewAmount));
            } else {
                return 'Annual Vacation Savings Plan Preview: {0} per month'.format(utils.formatMoney(monthlyAmount));
            }
        },

        getPerfectSaverImage: function (psPreviewAmount) {
            return psPreviewAmount > 0 ? 'perfectsaver_purple_nospace.png?v=2' : 'perfectsaver_green_nospace.png?v=4';
        },

        /**
         * Go grab nightly info for this room, given the current session data
         * @param {Ractive Event} e 
         */
        onGetRateDetails: function (e) {
            e.original.preventDefault();
            var r = e.context;
            r.loadingRateDetails = true;
            this.ractive.set(e.keypath, r);
            var roomData = r.planningData;
            $.postJSON('/api/booking/getratedetails/', roomData).then(function (nights) {
                r.Nights = nights;
                r.loadingRateDetails = false;
                this.ractive.set(e.keypath, r);
            }.bind(this), function (err) {
                var serverMsg = utils.tryGetValue(err, 'responseJSON.Message');
                var message = serverMsg != null ? '<br/><br/>{0}<br/><br/>'.format(serverMsg) : '';
                this.ractive.set(e.keypath + '.RateDetailsMessenger.Errors', ['There was a problem retrieving rate details.{0}Please try again later.'.format(message)]);
                r.loadingRateDetails = false;
                this.ractive.set(e.keypath, r);
            }.bind(this));
        },

        /**
         * simply update the member's phone.
         */
        onPhoneChange: function(e) {
            $.postJSON('/api/users/updatephone/?phone=' + this.ractive.get('data.user.Phone'))
             .then(null, function(err) {
                     return this.ractive.set('messenger.Errors', window.Utilities.getFriendlyErrors(err));
                }.bind(this));
        },

        cancelCheckRequest: function() {
            if (this.checkRequest != null) {
                this.checkRequest.abort();
            }  
        },

        unload: function () {
            if (this.ractive != null) { this.ractive.teardown(); }
            this.ractive = null;
            this.state = null;
            this.cancelCheckRequest();
        }
    };
});
